/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';
import Colors from '../../constants/Colors';
import {FontWeight, Text} from '../Text';
import {Breakpoints} from "../../constants/Breakpoints";
import {mediaHelper} from "../../utils/src";

const Main = styled.div`
  width: 340px;
  min-height: 100%;
`;


const Topo = styled.div`
  width: 90%;
  display: flex;
  align-items: center;
  background: #fff;
  height: 72px;
  padding: 0 0 16px 32px;

  border-bottom: 1px solid #C4C4C4; 
  margin: 5%;
  
  @media (min-width: ${Breakpoints.xl}) {
    width: 97%;
  }

  @media(max-width: ${Breakpoints.sm}) {
    width: 100%;
    height: 55px;
    border-bottom: 0px; 
  }
`;

const Title = styled(Text)`
  font-size: 14px;
  padding-left: 55px;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: ${FontWeight.Bold};
  color: ${Colors.GRAY[3]};
  margin-top: 25px;
  display: block;
  
`;

const List = styled.ul`
  width: 100%;
  min-height: 100px;
  list-style-type: none;
  padding-inline-start: 0px;
  margin-top: 5px;
  a{
    text-decoration: none;
  }
`;

const Item = styled(Text)`
  color: ${Colors.GRAY[3]};
  padding-left: 15px;
  margin: 10px 20px 35px 20px;
  display: block;

  p{
    margin: 0px;
    font-weight: ${FontWeight.Medium};
    font-size: 15px;
    line-height: auto;
  }

  span{
    font-weight: ${FontWeight.Bold};
    font-size: 14px;
    text-transform: uppercase;
    line-height: 17px;
    display: block;
  }

  i{
    margin-right: 20px;
    float: left;
    margin-top: 5px;
  }

  .icon-policies:before{
    background-size: 30px 28px;
    width: 30px;
    height: 28px;
  }

  .icon-claims:before{
    background-size: 30px 28px;
    width: 30px;
    height: 28px;
  }

  .icon-enquiries:before{
    background-size: 30px 28px;
    width: 30px;
    height: 28px;
  }
  
  .icon-payments:before{
    background-size: 30px 25px;
    width: 30px;
    height: 25px;
  }

  .icon-schedule:before{
    background-size: 26px 26px;
    width: 26px;
    height: 26px;
  }
  
  ${mediaHelper.sm `
    margin: 10px 20px 0px;
  `}
`;

const Remember = styled.div`
  margin-left: 20px;

  p{
    font-size: 14px;
    display: block;
  }

  span{
    font-size: 14px;
    display: block;
  }
`;

const SubTitle = styled(Text)`
  font-size: 16px;
  margin-left: 35px;
  color: ${Colors.GREEN};
  font-weight: ${FontWeight.Bold};
  opacity: 0.6;
  letter-spacing: 2px;
`;

const Container = styled.div`
  display: flex; 
  justify-content: center;
  align-items: center;
  flex-direction: column;
  
  .open{
    right: 0px;
    transition: all 1.5s;
  }
`;

const Settings = styled.div`
  bottom: 120px;
  left: 0;
  width: 100%;
  border-top: 2px solid #ccc;
  bottom:0;
  padding-bottom: 10px;
  border-top: 1px solid black; 
  margin-left: 5%; 

  span{
    line-height: 30px;
    font-weight: ${FontWeight.Bold};
    padding-left: 35px;
    i{
      margin-top: 0px;
    }
  }

  @media screen and (min-width: ${Breakpoints.lg}) {
    margin-top: unset;
  }

  @media(max-width: ${Breakpoints.sm}) {
    border-top: 1px solid black; 
  }
`;

const SettingsOptions = styled.div`
  display: inline-flex; 
  width: 100%;
  height: 100%;

  @media(max-width: ${Breakpoints.sm}) {
    display: inline-flex;
    font-size: 12px;

    .icon-user:before{
      width: 20px;
      height: 20px;
      background-size: 20px 20px;
    }
    .icon-logout:before{
      width: 20px;
      height: 20px;
      background-size: 20px 20px;
    }

  }

`;

const SettingsSubTitle = styled(Text)`
  font-size: 16px;
  margin-left: 5px;
  color: ${Colors.PRIMARY1};
  font-weight: ${FontWeight.Bold};
  opacity: 0.6;
  letter-spacing: 2px;
  margin-bottom: 20px;
  display: block;

  @media(max-width: ${Breakpoints.sm}) {
    display: block;
    font-size: 12px;
  }

`;

const SettingsList = styled.div`
  width: 100%;
  display: blocks; 
  align-items: center;
  min-height: 150px;
  list-style-type: none;
  padding-inline-start: 0px;
  margin-top: 20px;
  margin-bottom: -10px;
  a{
    text-decoration: none;
  }

  .active span{
    color:${Colors.PURPLE};
    margin-left: 1px;
    border-left: 4px solid ${Colors.GREEN};
    background: #fff;
    border-radius: 4px;
    box-shadow: 7px 5px 16px 4px rgba(177, 175, 175, 0.19);
  }
`;

const SettingsItem = styled(Text)`
  color: ${Colors.GRAY[3]};
  font-weight: ${FontWeight.Bold};
  padding-left: 55px;
  line-height: 50px;
  height: 50px;
  display: block;
  cursor:pointer;
  i{
    color: ${Colors.PURPLE};
    font-size: 27px;
    margin-right: 20px;
    float: left;
    margin-top: 10px;
  }
`;

export const UserPhoto = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  width: 52px;
  min-width: 52px;
  height: 52px;
  background: ${Colors.WHITE};
  box-shadow: 0px 8px 20px 3px rgba(171, 171, 171, 0.22);
  border-radius: 50px;
  align-items: center;
  justify-content: center;
`;

export const IconCheckContainer = styled.div`
  width: 26px;
  position: absolute;
  top: 32px;
  left: 36px;
`;

export const NameContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 16px;
`;

export const Name = styled(Text)`
  font-size: 16px;
  font-weight: ${FontWeight.ExtraBold};
  color: ${Colors.GRAY[6]};

  @media(max-width: ${Breakpoints.sm}){
    font-size: 12px;
  };
`;

export const Country = styled(Text)`
  font-size: 16px;
  font-weight: ${FontWeight.Regular};
  color: ${Colors.GRAY[6]};

  @media(max-width: ${Breakpoints.sm}){
    font-size: 12px;
  };
`;

export const IconNotification = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: red;
  color: ${Colors.WHITE};
  border-radius: 12px;
  font-size: 12px;
  font-weight: ${FontWeight.ExtraBold};
  width: 22px;
  height: 22px;
  position: absolute;
  top: 34px;
  left: 36px;
  cursor: pointer;
`;

export { Main, Topo, Title, List, Item, Remember, SubTitle, Container, Settings, SettingsSubTitle, SettingsItem, SettingsList, SettingsOptions };
